import React from 'react';
import {Link} from 'gatsby';
import {useIntl} from 'gatsby-plugin-intl';
import styles from './VacancyPreview.module.less';
import {Col} from 'antd';

const VacancyPreview = ({post, fullWidth = false}) => {
    const {locale} = useIntl();

    return (
        <Col
            xs={12}
            sm={12}
            md={fullWidth ? 12 : 6}
            lg={fullWidth ? 12 : 4}
            className={`${styles.container} ${fullWidth ? styles.fullWidth : ''}`}
        >
            <Link
                className={styles.item}
                to={`/${locale}/jobs/${post.slug}`}
            >
                <div
                    className={styles.title}
                    style={{borderColor: post.category.color}}
                >
                    <span
                        className="text text-semi-bold"
                        style={{color: post.category.color}}
                    >
                        {post.title}
                    </span>
                    <span>{post.employmentType}</span>
                </div>
            </Link>
        </Col>
    );
};

export default VacancyPreview;
